import { Hash } from 'viem';

export enum TransactionType {
  Deposit = 1,
  Transfer = 2,
  Withdraw = 3,
  Audit = 4,
}
export const TransactionTypeName = {
  [TransactionType.Deposit]: 'Deposit',
  [TransactionType.Transfer]: 'Transfer',
  [TransactionType.Withdraw]: 'Withdraw',
  [TransactionType.Audit]: 'Audit',
};

export interface CommitmentBaseDto {
  commitment: Hash;
  asset: Hash;
  amount: string;
  user_pk: Hash;
  is_frozen: boolean;
  is_spent: boolean;
  created_at: string | number;
}

export interface TransactionBaseDto<T = Hash> {
  txhash: Hash;
  tx_type: TransactionType;
  tx_index: number;
  relayer_fee: Hash | null;
  relayer_address: Hash | null;
  protocol_fee: Hash[] | null;
  evm_address: Hash | null;
  amount: Hash | null;
  created_at: string | number;
  inputs: Array<T> | null;
  outputs: Array<T> | null;
}
